import { LogicalOperatorEnum } from "../enums/LogicalOperatorEnum";
import { SoftwareVersionsSubset } from "./SoftwareVersionsSubset";

export class SoftwareVersionsFilter {
    softwareVersionsSubsets: SoftwareVersionsSubset[] = [];
    logicalOperator: LogicalOperatorEnum = LogicalOperatorEnum.And;

    public parse(obj: any) {
        if (obj.LogicalOperator != null && Object.values(LogicalOperatorEnum).includes(obj.LogicalOperator)) this.logicalOperator = obj.LogicalOperator;

        if (obj.SoftwareVersionsSubsets && obj.SoftwareVersionsSubsets.length > 0) {
            obj.SoftwareVersionsSubsets.forEach((e) => {
                let m: SoftwareVersionsSubset = new SoftwareVersionsSubset();
                m.parse(e);
                this.softwareVersionsSubsets.push(m);
            });
        }
    }

    clone(): SoftwareVersionsFilter {
        let result = new SoftwareVersionsFilter();

        result.logicalOperator = this.logicalOperator;
        this.softwareVersionsSubsets.forEach((element) => {
            result.softwareVersionsSubsets.push(element.clone());
        });

        return result;
    }
}
